import { createContext, useContext } from 'react';
import { DEFAULT_NATIONS, type Nations } from '../history.ts';

/** The nations of the sandbox game, for flags and names in the panels. */
export const SandboxNations = createContext<Nations>(DEFAULT_NATIONS);

export function useSandboxNations(): Nations {
  return useContext(SandboxNations);
}
